module.exports = __webpack_public_path__ + "img/4.68f28b1e.png";